import React from 'react';
import PropTypes from 'prop-types';
import { useTheme, createUseStyles } from 'react-jss';
import { Container, Icon, Typography } from '@sm/wds-react';
import { Logo } from '@sm/webassets';

import './endpage-header.scss';

const useStyles = createUseStyles(theme => {
  return {
    smEndpageHeaderLogo: {
      width: 247,
      height: 37,
      fontSize: theme.type.fontSize.hero2,
      color: theme.brandColors.neutral.white,
    },
    smEndpageHeader: {
      zIndex: theme.zIndex.sky,
    },
  };
});

const EndpageHeader = ({ copy, hasLogo, headerColor, headerType, icon }) => {
  const theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <Container
      p={6}
      flexJustify="center"
      className={`sm-endpage-header sm-endpage-header--${headerColor} sm-endpage-header--${headerType} ${classes.smEndpageHeader}`}
      data-testid="EndpageHeader"
    >
      <Typography align="center" component="section" variant="sectionTitle">
        <If condition={hasLogo}>
          <Logo className={classes.smEndpageHeaderLogo} />
          <br />
        </If>
        <Icon className="sm-endpage-header__icon wds-display--block wds-display--md-inline wds-m-r-2">{icon}</Icon>
        <Typography
          className="sm-endpage-header__copy wds-display--inline"
          align="center"
          component="section"
          variant="sectionTitle"
        >
          <strong>{copy}</strong>
        </Typography>
      </Typography>
    </Container>
  );
};

EndpageHeader.propTypes = {
  copy: PropTypes.string.isRequired,
  hasLogo: PropTypes.bool,
  headerColor: PropTypes.string,
  headerType: PropTypes.string,
  icon: PropTypes.string,
};

EndpageHeader.defaultProps = {
  hasLogo: false,
  headerColor: 'concord',
  headerType: undefined,
  icon: undefined,
};

export default EndpageHeader;
